/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Title_FirstInputs */

const en_us2_draft_title_first = /** @type {(inputs: Draft_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your first plan`)
};

const pt_br2_draft_title_first = /** @type {(inputs: Draft_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu primeiro plano`)
};

const es_419_draft_title_first = /** @type {(inputs: Draft_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu primer plan`)
};

const pt_pt2_draft_title_first = /** @type {(inputs: Draft_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu primeiro plano`)
};

const fr_fr2_draft_title_first = /** @type {(inputs: Draft_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton premier programme`)
};

const de_de2_draft_title_first = /** @type {(inputs: Draft_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein erster Plan`)
};

const it_it2_draft_title_first = /** @type {(inputs: Draft_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua prima scheda`)
};

/**
* | output |
* | --- |
* | "Your first plan" |
*
* @param {Draft_Title_FirstInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_title_first = /** @type {((inputs?: Draft_Title_FirstInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Title_FirstInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_title_first(inputs)
	if (locale === "es-419") return es_419_draft_title_first(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_title_first(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_title_first(inputs)
	if (locale === "de-DE") return de_de2_draft_title_first(inputs)
	if (locale === "it-IT") return it_it2_draft_title_first(inputs)
	return en_us2_draft_title_first(inputs)
});
export { draft_title_first as "draft.title_first" }